var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGroupColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "33px",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_group_color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gestionnaire---Param\\xE8tres",
    transform: "translate(-79.500000, -782.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(40.000000, 751.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_group_color",
    transform: "translate(36.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 40 0 40 40 0 40"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#AFBC9D",
    strokeWidth: 3,
    fill: "#AFBC9D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 15,
    cy: 11.6666667,
    r: 6.66666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,35 L5,31.6666667 C5,27.9847683 7.98476833,25 11.6666667,25 L18.3333333,25 C22.0152317,25 25,27.9847683 25,31.6666667 L25,35 L5,35 Z",
    id: "Path",
    stroke: "#AFBC9D",
    strokeWidth: 3,
    fill: "#AFBC9D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6666667,5.21666667 C29.6165247,5.97194965 31.6797388,8.62998525 31.6797388,11.675 C31.6797388,14.7200148 29.6165247,17.3780504 26.6666667,18.1333333",
    id: "Path",
    stroke: "#AFBC9D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,35 L35,31.6666667 C34.9826015,28.6409514 32.9296975,26.0063913 30,25.25",
    id: "Path",
    stroke: "#AFBC9D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGroupColor);
export default __webpack_public_path__ + "static/media/icon_group_color.b57bb87daa1e678ae0fc3bd17a0b2947.svg";
export { ForwardRef as ReactComponent };